import { render } from "./Experts.vue?vue&type=template&id=1999ac15&scoped=true"
import script from "./Experts.vue?vue&type=script&lang=js"
export * from "./Experts.vue?vue&type=script&lang=js"

import "./Experts.vue?vue&type=style&index=0&id=1999ac15&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1999ac15"]])

export default __exports__